import { clients } from '@oncolens/oncolens-ui/lib/api/client';
import { useQuery } from 'react-query';
import { OrganizationRegion } from '../types';
import { OrganizationKeys } from './organization.keys';

/**
 * Resolves the parent-inherited *effective* Region culture code for an org.
 *
 * The endpoint responds with a bare plain-text culture code ("en-US" / "en-IE"),
 * not JSON. The admin axios client parses JSON with `transitional.silentJSONParsing`
 * enabled, so a body that isn't valid JSON is returned untouched as the raw string
 * (JSON.parse fails silently and axios yields the original text). No manual parsing.
 */
export const getEffectiveRegion = async (orgId: string): Promise<OrganizationRegion> => {
  const response = await clients.admin.get(`/organizationsettings/ByOrg/${orgId}/region`);
  return response.data as OrganizationRegion;
};

export const useGetEffectiveRegion = (orgId: string | undefined, enabled: boolean) => {
  const definiteOrgId = orgId ?? '';
  return useQuery(
    OrganizationKeys.effectiveRegion(definiteOrgId),
    () => getEffectiveRegion(definiteOrgId),
    {
      enabled: enabled && orgId !== undefined,
    },
  );
};
